import React from 'react';

export const Ban: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='var(--primary-accent)'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    ></path>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 11.417a2.918 2.918 0 010-5.833 2.918 2.918 0 010 5.833zm0-4.667c-.962 0-1.75.788-1.75 1.75 0 .963.788 1.75 1.75 1.75.963 0 1.75-.787 1.75-1.75 0-.962-.787-1.75-1.75-1.75zM5.583 17.834H5.52A.587.587 0 015 17.192l.002-.012C5.045 16.88 5.829 12 12 12c1.068 0 2.048.17 2.91.496.304.117.45.45.34.752a.587.587 0 01-.753.339c-.735-.28-1.575-.42-2.497-.42-5.244 0-5.816 3.955-5.839 4.147a.581.581 0 01-.578.52zm9.421-3.069l.823-.822 1.073 1.079 1.073-1.074.823.823-1.073 1.073 1.073 1.074-.823.822-1.073-1.073-1.073 1.067-.823-.822 1.074-1.073-1.074-1.074z'
      clipRule='evenodd'
    ></path>
  </svg>
);
